var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { stringify } from 'querystring';
import { size } from 'lodash';
import fetch from 'isomorphic-fetch';
export const get = (url) => __awaiter(this, void 0, void 0, function* () {
    const res = yield fetch(url);
    if (res.status === 404) {
        return undefined;
    }
    if (!res.ok) {
        throw new Error(yield res.text());
    }
    return res.json();
});
export const toUrl = (path, params) => {
    const remainingParams = Object.assign({}, params);
    for (const key of Object.keys(params)) {
        if (path.includes(':' + key)) {
            if (params[key] === undefined) {
                throw Error('undefined provided as path param to ' + key + ' in ' + path + '. Did you use the right resource?');
            }
            path = path.replace(':' + key, params[key]);
            delete remainingParams[key];
        }
        if (params[key] === undefined ||
            params[key] === null ||
            (Array.isArray(params[key]) && params[key].length === 0)) {
            delete remainingParams[key];
        }
    }
    if (path.match(/:[a-zA-Z]/)) {
        throw Error('unmatched path component in ' + path);
    }
    if (size(remainingParams) === 0) {
        return path;
    }
    return path + '?' + stringify(remainingParams);
};
//# sourceMappingURL=util.js.map